module.exports = __webpack_public_path__ + "static/img/icon1.3ccecde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/sakura/sanliouLinkage/lottery/winning/icon1.png
// module id = L0md
// module chunks = 6